import PropTypes from 'prop-types';
import React from 'react';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
} from 'react-bootstrap';

import { fullDate, getCurrentDate, monthNameFormatDate } from '../../../core/date';
import StyledGriddle from '../../../components/StyledGriddle';
import { findById } from '../../../core/utils';
import Griddle, { plugins } from 'griddle-react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

const sortProperties = [
  { id: 'state', sortAscending: true },
];

export const styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲',
    },
  },
  classNames: {
    Row: 'row-class',
    Table: 'table-striped table',
    NextButton: 'btn btn-sm btn-success',
    PreviousButton: 'btn btn-sm btn-success'
  },
  styles: {
    Filter: { fontSize: 18 },
  },
};

const dateDisplay = ({ value }) => {
  return (
    <span> {monthNameFormatDate(value)} </span>
  )
}

const rowDataSelector = (state, { griddleKey }) => {
  return state
    .get('data')
    .find(rowMap => rowMap.get('griddleKey') === griddleKey)
    .toJSON();
};

const enhancedWithRowData = connect((state, props) => {
  return {
    rowData: rowDataSelector(state, props)
  };
});

class CommissionTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      showConfirmDeleteDialog: false,
      commisionId: 0,
      columnOrder: { "name": 0, "due": 0, "end": 0, "value": 0, "state": 0 },
      columnName: 'state',
      filterByCurrency: 'USD'
    }
    this.markAsPaid = this.markAsPaid.bind(this);
    this.removeConfirm = this.removeConfirm.bind(this)
    this.closeModal = this.closeModal.bind(this);
    this.removeCommissionAction = this.removeCommissionAction.bind(this);
    this.handleGenerateInvoice = this.handleGenerateInvoice.bind(this);
    this.InvoiceButtonColumn = this.InvoiceButtonColumn.bind(this);
    this.handleCurrencyFilterChange = this.handleCurrencyFilterChange.bind(this);
  }

  closeModal() {
    this.setState({
      showConfirmDeleteDialog: false,
    });
  }

  removeCommissionAction() {
    const id = (this.state.commisionId) ? this.state.commisionId : 0;
    const payload = { bid_id: id };
    let current_page = this.state.currentPage - 1;
    const filterByCurrency = this.state.filterByCurrency;
    if (id) {
      this.props.removeCommission(payload, current_page, filterByCurrency, (response) => {
        this.setState({ showConfirmDeleteDialog: false, commisionId: 0, modalText: '' });
      }
      );
    }
  }

  removeConfirm(e) {
    const id = e.currentTarget.getAttribute('data-item');
    e.preventDefault();
    this.setState({ showConfirmDeleteDialog: true, modalText: 'Are you sure want to delete commision?', commisionId: id });
  }

  markAsPaid(e) {
    e.preventDefault();
    const bidId = e.currentTarget.getAttribute('data-item');
    const payload = { id: bidId, paid: getCurrentDate() };
    this.props.editCommission(payload);
  }

  componentWillMount() {
    this.props.requestCommission(this.state.currentPage - 1, this.state.columnName, this.state.filterByCurrency);
  }

  handleCurrencyFilterChange(currency) {
    this.state.currentPage = 1;
    this.props.requestCommission(this.state.currentPage - 1, this.state.columnName, currency);
    this.state.filterByCurrency = currency;
  }


  // onNext = () => {
  //   this.props.requestCommission(this.state.currentPage, this.state.columnName, this.state.filterByCurrency);
  //   this.setState({
  //     currentPage: this.state.currentPage + 1
  //   })
  // }

  // onPrevious = () => {
  //   this.props.requestCommission(this.state.currentPage - 2, this.state.columnName, this.state.filterByCurrency);
  //   this.setState({
  //     currentPage: this.state.currentPage - 1
  //   })
  // }

  onColumnSort = (column) => {
    let columnName = '';

    if (column.id !== 'state')
      return


    if (this.state.columnOrder[column.id] == 0) {
      columnName = "-" + column.id
      this.state.columnOrder[column.id] = 1;
      sortProperties[0].sortAscending = false;
    }
    else {
      columnName = column.id
      this.state.columnOrder[column.id] = 0;
      sortProperties[0].sortAscending = true;
    }


    this.setState({
      columnName: columnName,
    });

    this.props.requestCommission(this.state.currentPage - 1, columnName, this.state.filterByCurrency);
    this.setState({
      currentPage: this.state.currentPage
    })

  }

  onGetPage = (pageNumber) => {
    this.props.requestCommission(pageNumber - 1, this.state.columnName, this.state.filterByCurrency);
    this.setState({
      currentPage: pageNumber
    });
  };

  handleGenerateInvoice(e){
    const bidId = e.currentTarget.getAttribute('data-item');
    const payload = { format: 'application/vnd.ms-excel', report: 'invoice' };
    this.props.downloadCommissionInvoice(bidId,payload);
  }

  InvoiceButtonColumn(row) {
    const bidId = row.rowData.id;
    if (row.rowData.state == "DUE" || row.rowData.state == "OVERDUE") {
      return (
        <ButtonGroup>
          <Button bsStyle="success" data-item={bidId} onClick={this.handleGenerateInvoice} title="Generate an Invoice">
            <i className="fa fa-files-o" /> Invoice
          </Button>
        </ButtonGroup>
      );
    }
    return null;
  }
  



  render() {
    if(this.props.currencyFilter){
      if(Object.keys(this.props.currencyFilter).length > 0){
        const currency = Object.keys(this.props.currencyFilter)[0];
        if(this.state.filterByCurrency !== currency){
          this.handleCurrencyFilterChange(currency);
        }
      }
    }
    const ButtonColumn = ({ value }) => {
      if (value) {
        return (
          <ButtonGroup>
            <Button bsStyle="success" data-item={value} onClick={this.markAsPaid} title="Mark as Paid">
              <i className="fa fa-check fa-lg" /> Paid
            </Button>
          </ButtonGroup>
        );
      }
      return null;
    };

    const DeleteButtonColumn = ({ value }) => {
      return (
        <ButtonGroup>
          <Button name="Remove" bsSize="small" data-item={value} bsStyle="success" onClick={this.removeConfirm} title="Remove Commission">
            <i className="fa fa-trash-o" />
          </Button>
        </ButtonGroup>
      )
    };

    const data = [];
    this.props.commissions.forEach((commission) => {
      const id = (commission.state !== 'PAID') ? commission.bid.id : null;
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: commission.bid.currency ? commission.bid.currency : 'USD',
        minimumFractionDigits: 2,
        // the default value for minimumFractionDigits depends on the currency
        // and is usually already 2
      });
      const newRow = {
        id,
        remove: commission.bid.id,
        name: commission.bid.hotel.name,
        value: formatter.format(commission.value),
        due: commission.due,
        end: commission.bid.max_date_details?commission.bid.max_date_details:commission.bid.bidset.event.end,
        state: commission.state,
        tour: commission.tour,
        invoice: commission.state,
      };
      data.push(newRow);
    });

    return (
      <div>
        <Griddle
          data={data}
          styleConfig={styleConfig}
          components={{
            Filter: () => <span />,
            SettingsToggle: () => <span />,
          }}
          pageProperties={{
            recordCount: this.props.count,
            currentPage: this.state.currentPage,
            pageSize: 25
          }}
          plugins={[plugins.LocalPlugin,plugins.PositionPlugin]}
          sortProperties={sortProperties}
          events={{
            onNext: this.onNext,
            onPrevious: this.onPrevious,
            onGetPage: this.onGetPage,
            onSort: this.onColumnSort
          }}
        >
          <RowDefinition>
            <ColumnDefinition id="name" title="Hotel" order={1} />
            <ColumnDefinition id="value" title="Amount" order={2} />
            <ColumnDefinition id="due" title="Due Date" order={3} customComponent={dateDisplay} />
            <ColumnDefinition id="end" title="Check Out" order={5} customComponent={dateDisplay} />
            <ColumnDefinition id="state" title="Status" order={6} headerCssClassName="profile-change" />
            <ColumnDefinition id="tour" title="Tour" order={7} />
            <ColumnDefinition id="id" title=" " order={10} customComponent={ButtonColumn} />
            <ColumnDefinition id="remove" title=" " order={11} customComponent={DeleteButtonColumn} />
            <ColumnDefinition id="invoice" title=" " order={12} customComponent={enhancedWithRowData(this.InvoiceButtonColumn)} />
          </RowDefinition>
        </Griddle>

        {this.state.showConfirmDeleteDialog && (<Modal show={this.state.showConfirmDeleteDialog} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Commission</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <p> {this.state.modalText !== '' ? this.state.modalText : 'Are you sure want to delete group?'}</p>

            <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.removeCommissionAction}
              >
                Confirm
              </Button>
              <Button
                bsStyle="success"
                onClick={this.closeModal}
              >
                Cancel
              </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}

      </div >
    );
  }
}

CommissionTable.propTypes = {
  commissions: PropTypes.arrayOf(PropTypes.object).isRequired,
  editCommission: PropTypes.func.isRequired,
  removeCommission: PropTypes.func.isRequired,
};

export default CommissionTable;



// WEBPACK FOOTER //
// src/routes/commissions/components/CommissionTable.js